import { apiUrl } from "../../ApiManager/AxiosHeaders";

export const dailyActivityApi = {
  getTasks: (date) =>
    apiUrl.get("daily-activity/tasks", { params: { date } }),

  createTask: (payload) => apiUrl.post("daily-activity/tasks", payload),

  updateTask: (id, payload) =>
    apiUrl.post(`daily-activity/tasks/${id}/update`, payload),

  updateStatus: (id, payload) =>
    apiUrl.post(`daily-activity/tasks/${id}/status`, payload),

  deleteTask: (id) => apiUrl.post(`daily-activity/tasks/${id}/delete`),

  reorder: (orderedIds) =>
    apiUrl.post("daily-activity/tasks/reorder", { ordered_ids: orderedIds }),

  sendTodayReport: () => apiUrl.post("daily-activity/send-report", { mode: "today" }),

  sendTomorrowPlan: () => apiUrl.post("daily-activity/send-report", { mode: "tomorrow" }),

  // Back-compat (currently unused): defaults to "today"
  sendReport: () => apiUrl.post("daily-activity/send-report", { mode: "today" }),

  getHistory: (params) =>
    apiUrl.get("daily-activity/history", { params }),

  getReportTasks: (reportId) =>
    apiUrl.get(`daily-activity/history/${reportId}/tasks`),

  getTodayTasks: () => apiUrl.get("daily-activity/today-tasks"),

  getFutureTasks: () => apiUrl.get("daily-activity/future-tasks"),

  getTodayReport: () => apiUrl.get("daily-activity/today-report"),
};